import { h, JSX } from 'preact';
import ObservingComponent from '../componentBases/observingComponent';
import { BoldReportsReportViewerPage } from 'core.frontend';

import '@boldreports/javascript-reporting-controls/scripts/common/bold.reports.common.min';
import '@boldreports/javascript-reporting-controls/scripts/common/bold.reports.widgets.min';
import '@boldreports/javascript-reporting-controls/scripts/data-visualization/ej.chart.min';
import '@boldreports/javascript-reporting-controls/scripts/bold.report-viewer.min';

enum ExportOptions {
    Pdf   = 1,
    Word  = 2,
    Excel = 4,
    CSV   = 8,
    PPT   = 16,
    HTML  = 32,
    XML   = 64,
    Doc   = 128,
    All   = 255
}

export interface BoldReportsViewerProps {
    page: BoldReportsReportViewerPage;
}

class BoldReportsViewer extends ObservingComponent<BoldReportsViewerProps> {

    public componentDidMount(): void {
        const { page } = this.props;
        const reportParams = page.options.reportParams
        const reportId = page.options.reportId
        const reportServiceUrl = page.reportServiceUrl
        const bearerToken = page.bearerToken

        $('#report-viewer')['boldReportViewer']({            
            reportServiceUrl: reportServiceUrl,
            reportPath: reportId ,
            parameters: reportParams,
            serviceAuthorizationToken: bearerToken,
            exportSettings: {
                exportOptions: ExportOptions.Pdf | ExportOptions.Excel
            }

            // ajaxBeforeLoad: function (args) {
            //     args.headers = args.headers || {};
            //     args.headers["Authorization"] = bearerToken;
            // }
        });
    }

    public render({ }: BoldReportsViewerProps): JSX.Element {

        return (
            <div style={{
                    width: '100%',
                    height: '900px',
                    minHeight: '450px',
                }}
                id="report-viewer">
            </div>
        );
    }
}

export default BoldReportsViewer;
